import {rootState} from '@mintdata-wsp/common/state/RootState';
import {action} from 'mobx';
import {PaymentMethodResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/PaymentMethodResponse';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {PaymentMethod} from '@mintdata-wsp/common/state/ui/storefront/PaymentMethod';

export class PaymentMethodController
{
    public syncPaymentInfo():void
    {
        controllers.net.billing
            .getCurrentPaymentMethod().then(action((resp:PaymentMethodResponse)=>
            {
                const paymentMethod = PaymentMethod.fromResponse(resp);
                rootState.ui.paymentMethod.currentPaymentMethod = paymentMethod;
            }));
    }

    public getCurrentPaymentMethod(): PaymentMethod | null
    {
        const {paymentMethod} = rootState.ui;
        const {currentPaymentMethod} = paymentMethod;

        if( !currentPaymentMethod )
            return null;

        return currentPaymentMethod;
    }
}
